// const CollapsibleItem = (classNameSelectors = '') => {
class CollapsibleItem {
  constructor(classNameSelectors) {
    this.classNameSelectors = classNameSelectors;
    this.init();
  }

  init() {
    if (!this.classNameSelectors) {
      return;
    }

    const collapsibleItem = document.querySelectorAll(
      `${this.classNameSelectors}`
    );

    collapsibleItem.forEach((item) => {
      item.addEventListener('click', function () {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    });
  }
}

export default CollapsibleItem;
